module.exports = __webpack_public_path__ + "img/roster-confirmation.5b08bd5f.svg";